module.exports = __webpack_public_path__ + "img/gmail.4de3b8f6.svg";